// Module
var code = "<span class=\"severity severity-{{issue.severity}}\">{{getSeverityDisplay()}}</span> ";
// Exports
module.exports = code;